import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Loader = ({ size = 6, className }) => {
    return (_jsxs("div", { role: "status", className: className, children: [_jsx("div", { "aria-hidden": "true", className: "border-brand-500 animate-spin rounded-full border-b-2", style: { width: size * 4, height: size * 4 } }), _jsx("span", { className: "sr-only", children: "Loading..." })] }));
};
export default Loader;
